import {
  defineButtonComponent,
  defineTextFieldComponent,
  defineDialogComponent,
  defineScaffoldComponent,
  defineAutocompleteComponent,
  defineSwitchComponent,
  defineCheckboxComponent,
  defineButtonToggleGroupComponent,
  defineButtonToggleComponent,
  defineTabComponent,
  defineTooltipComponent,
  defineRadioComponent,
  defineCircularProgressComponent,
  defineOptionComponent,
  defineStepperComponent,
  defineExpansionPanelComponent,
  defineIconButtonComponent,
  defineMenuComponent,
  defineInlineMessageComponent,
  defineBadgeComponent,
  defineToolbarComponent,
  defineIconComponent,
  definePaginatorComponent,
  defineCardComponent,
  defineAppBarComponent,
  defineAppBarMenuButtonComponent,
  defineAppBarHelpButtonComponent,
  defineAppBarProfileButtonComponent,
  defineDrawerComponent,
  defineListComponent,
  defineListItemComponent,
  defineSelectComponent,
  defineOpenIconComponent,
  definePopoverComponent,
  defineLabelValueComponent,
  defineTabBarComponent,
  defineDatePickerComponent,
  defineToastComponent,
  defineFilePickerComponent,
  defineSplitViewComponent,
  defineSplitViewPanelComponent,
  defineLinearProgressComponent,
  defineSkipLinkComponent,
  defineSplitButtonComponent,
  defineSliderComponent,
} from '@tylertech/forge';

import {
  defineUserProfileComponent,
  defineProfileLinkComponent,
  defineConfirmationDialogComponent,
  defineCountCardComponent
} from '@tylertech/forge-extended';

export const defineProgramInventoryComponents = () => {
  defineFilePickerComponent();
  defineSplitButtonComponent();
};

export const defineProgramInsightsComponents = () => {
  defineRadioComponent();
  defineLinearProgressComponent();
};

export const defineBudgetRequestsComponents = () => {
  defineStepperComponent();
};

export const defineManageOrganizationAccessComponents = () => {
  defineSwitchComponent();
};

export const defineManageUserAccessComponents = () => {
  defineSwitchComponent();
};

export const defineConfigureBudgetComponents = () => {
  defineSwitchComponent();
};

export const defineConfigureInsightsComponents = () => {
  defineSwitchComponent();
  defineLabelValueComponent();
  defineLinearProgressComponent();
};

export const defineConfigureRequestsComponents = () => {
  defineSwitchComponent();
  defineButtonToggleGroupComponent();
  defineButtonToggleComponent();
  defineRadioComponent();
  defineLabelValueComponent();
};

export const defineConfigureResultsComponents = () => {
  defineSwitchComponent();
  defineRadioComponent();
  defineLabelValueComponent();
};

export const defineBudgetSummaryComponents = () => {
  defineCheckboxComponent();
  defineStepperComponent();
  defineDatePickerComponent();
  defineFilePickerComponent();
};

export const defineCostAllocationComponents = () => {
  defineCheckboxComponent();
  defineButtonToggleGroupComponent();
  defineButtonToggleComponent();
  defineFilePickerComponent();
  defineSplitViewComponent();
  defineSplitViewPanelComponent();
};

export const defineDataVisualizationComponents = () => {
  defineCheckboxComponent();
  defineSplitViewComponent();
  defineSplitViewPanelComponent();
  defineSliderComponent();
};

export const defineManageUsersComponents = () => {
  defineCheckboxComponent();
  defineLabelValueComponent();
  defineFilePickerComponent();
};

export const defineFinalReviewComponents = () => {
  defineButtonToggleGroupComponent();
  defineButtonToggleComponent();
  defineFilePickerComponent();
};

export const defineUserActivityComponents = () => {
  defineDatePickerComponent();
};

export const defineReportsComponents = () => {
  defineFilePickerComponent();
};

export const defineCoreComponents = () => {
  defineButtonComponent();
  defineTextFieldComponent();
  defineDialogComponent();
  defineScaffoldComponent();
  defineAutocompleteComponent();
  defineTabComponent();
  defineTooltipComponent();
  defineCircularProgressComponent();
  defineOptionComponent();
  defineExpansionPanelComponent();
  defineIconButtonComponent();
  defineMenuComponent();
  defineInlineMessageComponent();
  defineBadgeComponent();
  defineToolbarComponent();
  defineIconComponent();
  definePaginatorComponent();
  defineCardComponent();
  defineAppBarComponent();
  defineAppBarMenuButtonComponent();
  defineAppBarProfileButtonComponent();
  defineDrawerComponent();
  defineListComponent();
  defineListItemComponent();
  defineSelectComponent();
  defineOpenIconComponent();
  definePopoverComponent();
  defineAppBarHelpButtonComponent();
  defineTabBarComponent();
  defineToastComponent();
  defineUserProfileComponent();
  defineProfileLinkComponent();
  defineConfirmationDialogComponent();
  defineSkipLinkComponent();
  defineCountCardComponent();
};

const DefineCoreComponents = () => {
  defineCoreComponents();
  return null;
};

export default DefineCoreComponents;
